import { Observation } from "../../api/StudyApi";
import * as React from "react";
import { Component } from "react";
import StateDropdown from "./StateDropdown";
import i18n from "i18next";

interface ObsButtonBarProps {
  obs: Observation;

  onChangeObsState(state: string): void;

  onChangeCardinality(card: number): void;

  onToggleHistory(): void;

  onAddValidatedBy(): void;

  onClickTargetObs(): void;

  onRemoveObs(): void;
}

export default class ObsButtonBar extends Component<ObsButtonBarProps> {
  render() {
    return (
      <div className="btn-group" role="group">
        <StateDropdown
          state={this.props.obs.state}
          group={true}
          color="secondary"
          displayExcluded={true}
          onChange={(evt) => this.props.onChangeObsState(evt)}
        />

        {this.props.obs.cardinality == 1 && (
          <button
            title={i18n.t("obs.obsPresent")}
            className="btn btn-secondary"
            onClick={(evt) => this.props.onChangeCardinality(0)}
          >
            <i className="fa fa-eye" />
          </button>
        )}

        {this.props.obs.cardinality == 0 && (
          <button
            title={i18n.t("obs.obsAbsent")}
            className="btn btn-danger"
            onClick={(evt) => this.props.onChangeCardinality(1)}
          >
            <i className="fa fa-eye-slash" />
          </button>
        )}

        <button
          title={i18n.t("obs.showHistory")}
          className="btn btn-secondary"
          onClick={(evt) => this.props.onToggleHistory()}
        >
          <i className="fa fa-book" />
        </button>

        <button
          title={i18n.t("obs.addValidation")}
          className="btn btn-secondary"
          onClick={(evt) => this.props.onAddValidatedBy()}
        >
          <span className="badge-container" data-count={this.props.obs.validatedBy.length}>
            <i className="fa fa-check" />
          </span>
        </button>

        <button
          title={i18n.t("obs.showRegions")}
          className="btn btn-secondary"
          onClick={(evt) => this.props.onClickTargetObs()}
          disabled={this.props.obs.regions.length <= 0}
        >
          <i className="fa fa-dot-circle-o" />
        </button>

        <button
          className="btn btn-secondary"
          title={i18n.t("global.delete")}
          onClick={(evt) => {
            evt.stopPropagation();
            this.props.onRemoveObs();
          }}
        >
          <i className="fa fa-trash" />
        </button>
      </div>
    );
  }
}
